import { Button } from '@mui/material';
import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { searchCatalogItemsActions } from 'features/SearchCatalogItems/model/slices/SearchCatalogItemsSlice';
import { useAppDispatch } from 'shared/lib/hooks/useAppDispatch';

interface AddItemsBackFromSearchButtonProps {
    isInventory: boolean;
}

export const AddItemsBackFromSearchButton = memo(
    ({ isInventory }: AddItemsBackFromSearchButtonProps) => {
        const { t } = useTranslation();
        const dispatch = useAppDispatch();

        const onClick = useCallback(() => {
            dispatch(searchCatalogItemsActions.resetSearch());
        }, [dispatch]);

        const label = isInventory
            ? t('Back to inventory')
            : t('Back to categories');

        return (
            <Button
                variant="outlined"
                color="primary"
                onClick={onClick}
                data-testclass="add-items-search-back"
                sx={{
                    height: '42px',
                    textTransform: 'none',
                }}
            >
                {label}
            </Button>
        );
    },
);
